import React from 'react';
import { motion } from 'framer-motion';
import { spring } from '../motion';

interface Option<T extends string> {
  value: T;
  label: string;
}

/** 切り替えタブ。選択中の白い札が滑って移動する。 */
export function Segmented<T extends string>({
  options,
  value,
  onChange,
  id,
}: {
  options: Option<T>[];
  value: T;
  onChange: (v: T) => void;
  id: string;
}) {
  return (
    <div className="v2-seg" role="group">
      {options.map((o) => (
        <button key={o.value} className="v2-seg-item" aria-pressed={o.value === value} onClick={() => onChange(o.value)}>
          {o.value === value && <motion.span layoutId={`seg-${id}`} className="v2-seg-pill" transition={spring} />}
          {o.label}
        </button>
      ))}
    </div>
  );
}
